import { DefaultDatasetDurationLimiter } from "@/services/license/license-limiters/dataset-duration-limiters/default-dataset-duration-limiter";
import { getUserUniqueStemSplitterDatasetDurationLimit } from "@/actions/db/user-unique-dataset-limits";

export class StemSplitterDatasetDurationLimiter extends DefaultDatasetDurationLimiter {
  getUniqueLimit(userId: string): Promise<number | null> {
    return getUserUniqueStemSplitterDatasetDurationLimit(userId);
  }
}
